import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ClipIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.7 5.12C14.44 3.38 17.24 3.38 18.98 5.12C20.72 6.86 20.72 9.66 18.98 11.4L10.44 19.94C9.18 21.2 7.14 21.18 5.9 19.94C4.62 18.66 4.62 16.66 5.9 15.38L14.4 6.86C15.16 6.1 16.46 6.12 17.22 6.88C17.98 7.64 18 8.94 17.24 9.7L8.4 18.52L7.3 17.42L16.12 8.6C16.3 8.42 16.3 8.14 16.12 7.98C15.96 7.8 15.68 7.8 15.5 7.98L7 16.48C6.36 17.12 6.36 18.2 7 18.84C7.64 19.46 8.7 19.46 9.34 18.84L17.86 10.3C18.98 9.18 19.02 7.34 17.88 6.22C16.76 5.08 14.92 5.12 13.8 6.24L4.96 15.06L3.86 13.96L12.7 5.12Z" />
    </SvgIcon>
  );
});
